import { Navigate } from "react-router";
import Toolbar from "../toolbar/toolbar";
import { useAuth } from "../../hooks/use-auth";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
	const auth = useAuth();

	if (auth === "loading") return null;
	if (auth === "unauthenticated") return <Navigate to="/login" replace />;
	return (
		<>
			<Toolbar />
			{children}
		</>
	);
};

export default PrivateRoute;
